import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';

import {
  errorNotification,
  successNotification,
} from '../../components/notifications';
import api from '../../libs/api';

const initialState = {
  userMisReport: null,
  stageResponsibles: [],
};

export const getUserMisReport = createAsyncThunk(
  'userMis/getUserMisReport',
  async query => {
    const { data } = await api.get('/user-mis/reports/weekly', query);

    return data;
  },
);

export const getStageResponsibles = createAsyncThunk(
  'userMis/getStageResponsibles',
  async query => {
    const { data } = await api.get('/user-mis/stage-responsibles', query);

    return data;
  },
);

export const updateStageResponsible = createAsyncThunk(
  'userMis/updateStageResponsible',
  async ({ stageKey, userId }) => {
    const { data } = await api.put(`/user-mis/stage-responsibles/${stageKey}`, {
      userId,
    });

    successNotification('Stage responsible updated successfully');
    return data;
  },
);

const userMis = createSlice({
  name: 'userMis',

  initialState,

  reducers: {
    clearUserMisReport: draft => {
      draft.userMisReport = initialState.userMisReport;
    },
  },

  extraReducers: builder => {
    builder.addCase(getUserMisReport.fulfilled, (draft, { payload }) => {
      draft.userMisReport = payload;
    });

    builder.addCase(getStageResponsibles.fulfilled, (draft, { payload }) => {
      draft.stageResponsibles = payload;
    });

    builder.addCase(updateStageResponsible.fulfilled, (draft, { payload }) => {
      const index = draft.stageResponsibles.findIndex(
        s => s.stageKey === payload.stageKey,
      );
      if (index !== -1) {
        draft.stageResponsibles[index] = {
          ...draft.stageResponsibles[index],
          ...payload,
        };
      }
    });

    builder.addMatcher(
      isAnyOf(
        getUserMisReport.rejected,
        getStageResponsibles.rejected,
        updateStageResponsible.rejected,
      ),
      (_draft, { error }) => {
        errorNotification(error);
      },
    );
  },
});

export const { clearUserMisReport } = userMis.actions;

export default userMis.reducer;
